import routerOptions0 from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.17.6_@types+node@24.0.15_@vue+compiler-sfc@3.5.17_eslint@9.31.0_rollup@4.45.1_sa_30461cca56061039e3e1df146f09011e/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}